export default __webpack_public_path__ + "img/1_8-3a216d66.png";